<template>
    <section class="designs-toolbar" aria-label="Design filters">
        <div class="toolbar__tabs">
            <button class="tab active" type="button">Recently viewed</button>
            <button class="tab" type="button">Shared files</button>
            <button class="tab" type="button">Shared projects</button>
        </div>
        <div class="toolbar__filters">
            <button class="chip" type="button">All organizations ?</button>
            <button class="chip" type="button">All files ?</button>
            <button class="chip" type="button">Last viewed ?</button>
            <button class="chip view" type="button">?</button>
        </div>
    </section>
</template>

<script>
export default {
    name: "ToolbarComp"
}
</script>

<style scoped>

.designs-view {
    height: 100vh;
    overflow: hidden;
    display: grid;
    grid-template-columns: 280px 1fr;
    background: var(--bg);
    color: var(--text);
    font-family: 'Inter', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, 'Apple Color Emoji', 'Segoe UI Emoji';
}

.sidebar {
    background: #121721;
    border-right: 1px solid var(--border);
    display: grid;
    grid-template-rows: auto auto 1fr auto auto;
    padding: 20px 18px;
    gap: 24px;
}

.sidebar__profile {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
}

.avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4ea1ff, #7f9cf5);
    display: grid;
    place-items: center;
    font-weight: 700;
}

.profile__text { display: flex; flex-direction: column; gap: 2px; }
.profile__name { font-weight: 600; }
.profile__email { color: var(--muted); font-size: 12px; }
.sidebar__collapse { border: none; background: transparent; color: var(--muted); cursor: pointer; font-size: 18px; }

.sidebar__search input {
    width: 100%;
    height: 36px;
    border-radius: 10px;
    border: 1px solid var(--border);
    background: var(--panel-2);
    color: var(--text);
    padding: 0 12px;
}

.sidebar__nav { display: grid; gap: 6px; }
.nav-item {
    height: 34px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: var(--muted);
    text-align: left;
    padding: 0 12px;
    font-size: 13px;
    cursor: pointer;
}

.nav-item:hover,
.nav-item.active {
    background: rgba(78, 161, 255, 0.15);
    color: var(--text);
}

.sidebar__section-label {
    margin: 14px 0 6px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: var(--muted);
}

.sidebar__plan {
    border-radius: 14px;
    background: linear-gradient(160deg, rgba(78, 161, 255, 0.18), rgba(78, 161, 255, 0.04));
    border: 1px solid var(--border);
    padding: 16px;
    display: grid;
    gap: 10px;
}

.sidebar__plan h3 { margin: 0; font-size: 15px; }
.sidebar__plan p { margin: 0; color: var(--muted); font-size: 12px; }
.sidebar__footer { color: var(--muted); font-size: 13px; }

.stage {
    display: flex;
    flex-direction: column;
    gap: 28px;
    padding: 28px 36px 48px;
}

.stage__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.stage__pills { display: flex; gap: 10px; }
.pill {
    height: 32px;
    border-radius: 999px;
    border: 1px solid var(--border);
    padding: 0 18px;
    background: transparent;
    color: var(--muted);
    cursor: pointer;
    font-size: 13px;
}

.pill.active {
    background: rgba(78, 161, 255, 0.2);
    color: var(--text);
}

.stage__actions { display: flex; gap: 10px; }

.btn {
    height: 36px;
    border-radius: 10px;
    border: 1px solid var(--border);
    background: var(--panel-2);
    color: var(--text);
    cursor: pointer;
    padding: 0 16px;
    font-weight: 600;
}

.btn.ghost { background: transparent; }
.btn.primary { background: var(--accent); border-color: var(--accent); color: #fff; }
.btn.danger { color: #ff6b6b; }

.recommendations {
    border-radius: 20px;
    border: 1px solid var(--border);
    background: var(--panel);
    padding: 20px 24px 24px;
    display: grid;
    gap: 18px;
}

.recommendations__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.recommendations__rail {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(260px, 1fr);
  gap: 18px;
  overflow-x: auto;
  padding-bottom: 6px;
}

.recommendation-card {
  border-radius: 16px;
  border: 1px solid var(--border);
  background: var(--panel-2);
  display: grid;
  gap: 12px;
  padding: 14px;
  min-height: 220px;
}

.recommendation-thumb {
  border-radius: 12px;
  height: 120px;
  display: grid;
  place-items: center;
  color: #f9fafb;
  font-weight: 600;
  text-align: center;
  padding: 0 16px;
}

.recommendation-meta h3 { margin: 0; font-size: 15px; }
.meta__source { margin: 6px 0 0; color: var(--muted); font-size: 12px; }
.meta__stats { margin: 8px 0 0; color: var(--muted); font-size: 12px; display: flex; gap: 8px; }

.designs-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.toolbar__tabs { display: flex; gap: 8px; }
.tab {
  height: 32px;
  padding: 0 14px;
  border-radius: 16px;
  border: none;
  background: transparent;
  color: var(--muted);
  font-size: 13px;
  cursor: pointer;
}

.tab.active { background: rgba(78, 161, 255, 0.18); color: var(--text); }
.toolbar__filters { display: flex; gap: 10px; }

.chip {
  height: 32px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--panel-2);
  color: var(--muted);
  cursor: pointer;
  padding: 0 12px;
  font-size: 12px;
}

.chip.view { width: 36px; text-align: center; padding: 0; }
.chip:hover { color: var(--text); }

.design-groups { display: grid; gap: 36px; }
.design-group { display: grid; gap: 18px; }

.design-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.design-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
}

.design-card {
  border: 1px solid var(--border);
  border-radius: 16px;
  background: var(--panel);
  display: grid;
  overflow: hidden;
}

.design-card__click {
  all: unset;
  display: grid;
  gap: 14px;
  padding: 16px;
  cursor: pointer;
}

.design-card__thumb {
  height: 140px;
  border-radius: 12px;
  background: var(--panel-2);
  border: 1px solid var(--border);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.design-card__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.design-card__placeholder {
  color: rgba(231, 235, 243, 0.8);
  font-size: 28px;
  font-weight: 700;
}

.design-card__meta h3 { margin: 0; font-size: 15px; }
.design-card__desc { margin: 6px 0 0; color: var(--muted); font-size: 12px; }

.design-card__footer {
  padding: 0 16px 16px;
  display: flex;
  gap: 10px;
}

.chip.danger { color: #ff6b6b; }

.empty-banner {
  border: 1px dashed var(--border);
  border-radius: 20px;
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.empty-banner__icon { font-size: 32px; }
.empty-banner__text h3 { margin: 0 0 6px; }
.empty-banner__text p { margin: 0; color: var(--muted); font-size: 13px; }

@media (max-width: 1100px) {
  .designs-view { grid-template-columns: 240px 1fr; }
  .stage { padding: 24px; }
  .recommendations__rail { grid-auto-columns: minmax(220px, 1fr); }
}

@media (max-width: 900px) {
  .designs-view { grid-template-columns: 1fr; }
  .sidebar { display: none; }
  .stage { padding: 20px; }
}

@media (max-width: 640px) {
  .stage__header { flex-direction: column; align-items: flex-start; }
  .stage__actions { width: 100%; justify-content: flex-start; }
  .designs-toolbar { flex-direction: column; align-items: flex-start; }
  .toolbar__filters { flex-wrap: wrap; }
}

</style>